import { AiSlotState } from '@store/slices/aiSlot.slice'
import { AudioSourceType } from '@shared/enums'

export const enumToOptions = <T extends object>(
  e: T
): Array<{ id: string; label: string }> => {
  return Object.keys(e).map((key) => ({
    id: key as string,
    label: e[key as keyof T] as string,
  }))
}

export const getSlotStateName = (state: AiSlotState): string => {
  switch (state) {
    case AiSlotState.NEW:
      return 'Nové'
    case AiSlotState.OUTLINE:
      return 'AI návrh'
    case AiSlotState.TEXT:
      return 'Text'
    case AiSlotState.PARTIALLY_AUDIO:
      return 'Částečně audio'
    case AiSlotState.AUDIO:
      return 'Audio'
    case AiSlotState.PARTIALLY_PUBLISHED:
      return 'Částečně publikováno'
    case AiSlotState.PUBLISHED:
      return 'Publikováno'
    default:
      return 'Neznámý stav slotu'
  }
}

export const getAudioSourceType = (
  type: string
): AudioSourceType | undefined => {
  switch (type.toUpperCase()) {
    case 'TEXT':
      return AudioSourceType.TEXT
    case 'SSML':
      return AudioSourceType.SSML
    case 'DIALOGUE':
      return AudioSourceType.DIALOGUE
    case 'PHONETIC':
      return AudioSourceType.PHONETIC
    default:
      console.warn(`Unknown AudioSourceType: ${type}`)
      return undefined
  }
}
